import './Footer.css';
import logo from '../assets/logo.jpeg';

function Footer() {
  return (
    <div className="app-footer bg-dark-blue">
        <div className="grid max-sm:grid-rows-2 grid-cols-2 md:grid-cols-4 h-[20hv] place-content-evenly p-5 md:p-10  md:gap-5">

            <div className="flex flex-nowrap items-center col-span-2">
                <img src={logo} className="app-logo-footer ml-5" alt="logo" />
                <div className="text-left text-xl pl-5 md:w-3/4 text-white">
                    Praça Sebastião Gil n°. 107, Faria Lima, Pinheiros. <br />São Paulo - SP
                </div>
            </div>
            
            <div className="place-self-start place-content-center flex flex-wrap md:place-content-start md:pt-10 max-md:pb-10">
                <div className="text-left font-bold text-xl pl-5 md:w-3/4 text-white">
                    Nosso Trabalho
                </div>
                <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br text-base md:text-left text-center w-full pl-5 h-[40px]">
                    <a href="https://hotmart.com/pt-br/marketplace/produtos/destino-poliglota/A99073686Q" target='_blank' rel='noopener noreferrer'>
                        Curso DP</a>
                </button>
                <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br text-base md:text-left text-center w-full pl-5 h-[40px]">
                    <a href='/assets/o_metodo_vivencia_poliglota.pdf' target='_blank' rel='noopener noreferrer'>
                        Método DP</a>
                </button>
                <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br text-base md:text-left text-center w-full pl-5 h-[40px]">
                    <a href="https://hotmart.com/pt-br/marketplace/produtos/destino-poliglota/A99073686Q" target='_blank' rel='noopener noreferrer'>
                        Tutores</a>
                </button>
                <button type="button" className="hidden text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br text-base md:text-left text-center w-full pl-5 h-[40px]">
                    <a href="https://blog.destinopoliglota.com.br" target='_blank' rel='noopener noreferrer'>
                        Blog</a>
                </button>
            </div>

            <div className="place-content-center flex flex-wrap md:place-content-start md:pt-10 max-md:pb-10">
                <div className="text-left font-bold text-xl pl-5 md:w-3/4 text-white">
                    Contatos
                </div>
                    
                <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br text-base md:text-left text-center w-full pl-5 h-[40px]">
                    <a href="https://web.whatsapp.com/send?phone=559132302292" target='_blank' rel='noopener noreferrer'>
                        Whatsapp</a>
                </button>
                <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br text-base md:text-left text-center w-full pl-5 h-[40px]">
                    <a href="https://www.instagram.com/destinopoliglota/" target='_blank' rel='noopener noreferrer'>
                        Instagram</a>
                </button>
                <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br text-base md:text-left text-center w-full pl-5 h-[40px]">
                    <a href="https://www.youtube.com/@DestinoPoliglota" target='_blank' rel='noopener noreferrer'>
                        YouTube</a>
                </button>
                <button type="button" className="text-white bg-dark-blue from-blue-500 via-blue-600 to-blue-700 
                    hover:bg-gradient-to-br text-base md:text-left text-center w-full pl-5 h-[40px]">
                    <a href="mailto:contato@destinopoliglota.com.br" target='_blank' rel='noopener noreferrer'>
                        E-mail</a>
                </button>
            </div>
        </div>
    </div>
  );
}

export default Footer;
